"use strict";
exports.__esModule = true;
function createSingleton(factory, dbgGlobalName) {
    if (dbgGlobalName === void 0) { dbgGlobalName = null; }
    var instance = null;
    return function () {
        if (!instance) {
            instance = factory();
            if (dbgGlobalName && typeof window !== 'undefined') {
                window[dbgGlobalName] = instance;
            }
        }
        return instance;
    };
}
exports.createSingleton = createSingleton;
function createObjectsCache(factory, dbgGlobalName) {
    if (dbgGlobalName === void 0) { dbgGlobalName = null; }
    var instanceCache = {};
    if (dbgGlobalName && typeof window !== 'undefined') {
        window[dbgGlobalName] = instanceCache;
    }
    var get = function (id) {
        if (id in instanceCache) {
            var obj = instanceCache[id];
            return obj.retain ? obj.retain() : obj;
        }
        else {
            var obj = factory(id); // counter = 1, no retain needed
            instanceCache[id] = obj;
            return obj;
        }
    };
    var remove = function (id) {
        console.assert(id in instanceCache);
        delete instanceCache[id];
    };
    return { get: get, remove: remove };
}
exports.createObjectsCache = createObjectsCache;
